import axios from 'axios';
import config from '../config';
import { forceLogin } from '../actions/auth';
import { getBaseUrlFromConfig } from '../utils/url_helpers';

export function axios401ResponseInterceptor() {
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const biztechApiBaseUrl = getBaseUrlFromConfig(config.biztechApi);
      const urlObj = error.config ? new URL(error.config.url) : null;
      const errorType = error?.response?.data?.type;
      if (
        error.response &&
        (error.response.status === 401 ||
          (error.response.status === 403 && errorType === 'ACCESS_DENIED')) &&
        error.config &&
        error.config.url.includes(biztechApiBaseUrl) &&
        urlObj &&
        !urlObj.pathname.includes('logout')
      ) {
        console.error(
          'Your session has expired. Redirecting to the login page.'
        );
        forceLogin();
      }
      return Promise.reject(error);
    }
  );
}
